module.exports = __webpack_public_path__ + "static/img/192_TO8_2085.3486028.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/192_TO8_2085.jpg
// module id = jUb1
// module chunks = 0